// extracted by mini-css-extract-plugin
export var text = "_3m-0";